import { ServiceLevelName } from 'types/service-level';
import { serviceLevelsMarketing } from '@constants';

export const serviceLevelWithPlansByName = (serviceLevel: ServiceLevelName | undefined): boolean => {
	switch (serviceLevel) {
		case 'STARTER':
		case 'BASIC':
			return false;
		case 'CORE':
		case 'ADVANCED':
		case 'PREMIUM':
			return true;
	}
	return false;
};

export const getServiceLevelSubtitle = (serviceLevel: ServiceLevelName | string): string => {
	return serviceLevelsMarketing.find((sl) => sl.name === serviceLevel)?.updatedSubtitle ?? '';
};
